export function parseDownloadFilename(disposition: string | null | undefined, fallback: string): string {
  if (!disposition) return fallback

  const starMatch = disposition.match(/filename\*=(?:RFC5987|utf-8|UTF-8)''([^;\n]+)/i)
  if (starMatch?.[1]) {
    try {
      return decodeURIComponent(starMatch[1].trim())
    } catch {
      // fall through
    }
  }

  const quotedMatch = disposition.match(/filename="([^"]+)"/i)
  if (quotedMatch?.[1]) {
    return quotedMatch[1]
  }

  const plainMatch = disposition.match(/filename=([^;\n]+)/i)
  if (plainMatch?.[1]) {
    return plainMatch[1].trim().replace(/^["']|["']$/g, '')
  }

  return fallback
}
